// extracted by mini-css-extract-plugin
export default {"btn":"ImageModal_btn__RtgMV"};